import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationDurationPluginService extends InspectionPluginService {
  private unitsKeys = [
    { value: 1, label: 'plugins.installationduration.minutes' },
    { value: 2, label: 'plugins.installationduration.hours' },
    { value: 3, label: 'plugins.installationduration.days' }
  ];

  private units = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getTimeUnits() {
    return this.units;
  }

  public updateDuration(inspectionId: string, pointId: string, pluginId: string, duration: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, duration).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.units = [];
    this.copyTranslationValues(this.unitsKeys, this.units, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, duration: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, duration, 'Duration').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
